import axios from 'axios'
import { config } from 'shelljs';
var pointGroups = [];
var pointMarkers = [];
var lineGroups = [];
var overlayGroups = [];
export default {
  //新的封装
  //时间戳转变为各种格式
  time(t, j) {
    if (this.isEmpty(t)) {
      return '';
    }
    var d = new Date(t);
    var result;
    var yy = d.getFullYear();
    var mm = d.getMonth() < 9 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
    var dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
    var h = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
    var m = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    var s = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
    if (j == 'yymmdd') {
      result = yy + '-' + mm + '-' + dd
    } else if (j == 'zhyymmdd') {
      result = yy + '年' + mm + '月' + dd + '日'
    } else if (j == 'yymm') {
      result = yy + '-' + mm
    } else if (j == 'zhyymm') {
      result = yy + '年' + mm + '月'
    } else if (j == 'yymmddhhmm') {
      result = yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
    } else {
      result = yy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + s
    }
    return result
  },
  //时间戳变为时间对象
  sjcTo(t) {
    if (this.isEmpty(t)) {
      return ''
    } else {
      return new Date(t)
    }
  },
  //对象格式改为时间戳
  toSjc(t) {
    if (this.isEmpty(t)) {
      return ''
    } else {
      return t.getTime();
    }
  },
  //文本处理
  text(t, k) {
    if (this.isEmpty(t)) {
      return k || '';
    } else {
      return t;
    }
  },
  //近几天快速选择
  days(t1, t2) {
    //获取今天0点时间戳
    var t = new Date(new Date().toLocaleDateString());
    var start = t.getTime() + 86400000 * t1;
    var end = ''
    t2 == 0 ? end = Date.now() : end = t.getTime() + 86400000 * t2 + 86399000
    return { start: start, end: end }
  },
  //地址解析
  jiexi(pointList, pointType) {
    var params = {
      pointList: pointList,
      pointType: pointType = pointType || 2
    }
    var promise = new Promise((resolve) => {
      axios({
        method: "post",
        url: axios.serverWeb + "/map/geocoding",
        data: params,
      }).then((res) => {
        if (res.data.code == 200) {
          resolve(res.data.data);
        }
      });
    });
    return promise
  },
  //渲染标注点
  showPoints(map, v) {
    map.remove(pointGroups);
    var polyArrs = [];
    map.remove(pointMarkers);
    var icon = new AMap.Icon({
      size: new AMap.Size(26, 26), // 图标尺寸
      image:
        "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png", // Icon的图像
      imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
      imageSize: new AMap.Size(16, 26), // 根据所设置的大小拉伸或压缩图片
    });
    for (var i = 0, marker; i < v.length; i++) {
      marker = new AMap.Marker({
        map: map,
        position: [v[i].gcj02x, v[i].gcj02y],
        icon:icon, 
        //offset: new AMap.Pixel(-10, -30),
        zIndex: 2
      });
      marker.setLabel({
        offset: new AMap.Pixel(0, 40), //设置文本标注偏移量
        content:
          "<div class='myInfo' style='font-size:12px'>" +
          v[i].name +
          "</div>", //设置文本标注内容
        direction: "top", //设置文本标注方位
      });
      pointMarkers.push(marker);
      var circle = new AMap.Circle({
        center: [v[i].gcj02x, v[i].gcj02y],
        radius: v[i].radius, //半径
        borderWeight: 3,
        strokeColor: "#FF33FF",
        strokeOpacity: 0.2,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.2,
        strokeStyle: "dashed",
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: "#1791fc",
      });
      polyArrs.push(circle);
    }
    pointGroups = new AMap.OverlayGroup(polyArrs);
    map.add(pointGroups);
    //map.setFitView();
  },
  //渲染路线
  showLines(map, v) {
    map.remove(lineGroups);
    // lineGroups
    var polyArrs = [];
    var paths = [];
    for (var i = 0; i < v.length; i++) {
      var add = [];
      for (const j in v[i].pointList) {
        var dd = v[i].pointList[j];
        var small = new AMap.LngLat(dd.gcj02x, dd.gcj02y);
        add.push(small);
      }
      paths.push(add);

      // 创建线实例
      var polyline = new AMap.Polyline({
        path: paths[i],
        borderWeight: 4,
        strokeColor: "red",
      });
      polyArrs.push(polyline);
    }
    lineGroups = new AMap.OverlayGroup(polyArrs);
    map.add(lineGroups);
    //map.setFitView();
    //原有的图形
  },
  //渲染围栏
  showFences(map, v) {
    map.remove(overlayGroups);
    if (v.length == 0) {
      return;
    }
    var polyArrs = [];

    var paths = [];
    for (var i = 0; i < v.length; i++) {
      var add = [];
      for (const j in v[i].regionList) {
        var dad = [];
        for (const k in v[i].regionList[j]) {
          var dd = v[i].regionList[j][k];
          var small = new AMap.LngLat(dd.gcj02x, dd.gcj02y);
          dad.push(small);
        }
        add.push(dad);
      }
      paths.push(add);
      // 创建线实例
      var polygon = new AMap.Polygon({
        path: paths[i],
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        //fillColor: "#309ef8",
        fillColor: "green",
        zIndex: 50
      });
      polyArrs.push(polygon);
    }
    overlayGroups = new AMap.OverlayGroup(polyArrs);
    map.add(overlayGroups);
    //map.setFitView();
  },
  //方向
  direction(t) {
    var d = {
      1: "北",
      2: "东北",
      3: "东",
      4: "东南",
      5: "南",
      6: "西南",
      7: "西",
      8: "西北",
    }
    return this.isEmpty(t) ? '无' : d[t];
  },
  //相对时间计算
  xdsj(start) {
    var dd = (Date.now() - start) / 1000;
    var time = '';
    if (start == null) {
      time = "";
    } else {
      if (dd < 0) {
        time = 0;
      } else if (0 <= dd && dd < 60) {
        //1分钟内
        time = "刚刚";
      } else if ((60 <= dd) & (dd < 3600)) {
        //1小时内
        time = parseInt(dd / 60) + "分钟前";
      } else if (3600 <= dd && dd < 24 * 3600) {
        //大于1小时小于24小时
        time = parseInt(dd / 3600) + "小时前";
      } else if (24 * 3600 <= dd) {
        //超过24小时
        time = parseInt(dd / (3600 * 24)) + "天前";
      }
    }
    return time;
  },
  //分钟转换小时
  minTime(t) {
    if (t <= 60) {
      return t + '分钟'
    } else if (t > 60) {
      return parseInt(t / 60) + '小时' + t % 60 + '分'
    }
  },
  //取到的值为空的处理
  isEmpty(param) {
    if (param == null || param.length == 0 || param == 'null') {
      return true;
    } else {
      return false;
    }
  },
  //导出报表
  exportData(url, params) {
    var href =
      url +
      "?identityId=" +
      axios.keyObj.identityId +
      "&token=" +
      axios.keyObj.token
      +
      "&share=" +
      axios.keyObj.share
    for (const i in params) {
      href += "&" + params[i].name + "=" + params[i].value;
    }
    window.open(href);
  },
  //导出报表
  downLoad(url) {
    var href =
      url +
      "?identityId=" +
      axios.keyObj.identityId +
      "&token=" +
      axios.keyObj.token
      +
      "&share=" +
      axios.keyObj.share
    /* for (const i in params) {
      href += "&" + params[i].name + "=" + params[i].value;
    } */
    window.open(href);
  },
  //加载动画
  loading(that, text) {
    that.$Spin.show({
      render: h => {
        return h("div", [
          h("Icon", {
            class: "demo-spin-icon-load",
            props: {
              type: "ios-loading",
              size: 40
            }
          }),
          h("div", text)
        ]);
      }
    });
  },
  //货币格式转换
  formatMoney(number, places, symbol, thousand, decimal) {
    number = number || 0;
    places = !isNaN((places = Math.abs(places))) ? places : 2;
    //symbol = symbol !== undefined ? symbol : "￥";
    thousand = thousand || ",";
    decimal = decimal || ".";
    var negative = number < 0 ? "-" : "",
      i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      //symbol +
      negative +
      (j ? i.substr(0, j) + thousand : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) +
      (places
        ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
        : "")
    );
  },
  //旧的
  ale(_this, m) {
    //alert(m);
    _this.$Message.error(m);
  },
  alarm(_this, code, msg) {
    if (code == 300) {
      _this.$Message.error("文件大小错误");
    } else if (code == 200) {
      _this.$Message.error("格式错误");
    } else if (code == 500) {
      return
    } else if (code == 700) {
      _this.$Message.error("无效用户");
    } else if (code == 800) {
      return;
    } else {
      _this.$Message.error(msg);
    }
  },
  ac(vueObject) {
    console.log(vueObject); //如何让这里的this这项vue实例的this，就是借用了参数，在实例中把改参数换成this接口
  },
  //设置表格高度
  setTableHeight(id) {
    //j为调整值得
    //var h = document.body.clientHeight;
    //h = h - j;
    var h=document.getElementById(id)
    return h;
  },
  toSearchData(vueObject, search) {
    //表格内容搜索
    if (search) {
      vueObject.searchData = vueObject.products.filter(function (product) {
        //console.log(product)
        return Object.keys(product).some(function (key) {
          //console.log(key)
          return (
            String(product[key])
              .toLowerCase()
              .indexOf(search) > -1
          );
        });
      });
    } else {
      vueObject.searchData = vueObject.products;
    }
  },
  //时间转换 年月日时分秒
  day(t) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return (
        d.getFullYear() +
        "-" +
        m +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds()
      );
    } else {
      return t;
    }
  },
  //时间转换 年月日
  yyMmDd(t, val) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return d.getFullYear() + "-" + m + "-" + d.getDate() + " " + val;
    } else {
      if (val == undefined) {
        return t
      } else {
        return t + " " + val;
      }
    }
  },
  //报表导出需要
  changeToYyMmDd(t) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return d.getFullYear() + "-" + m + "-" + d.getDate()
    } else {
      return t
    }
  },
  //报表导出需要
  changeToYyMm(t) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return d.getFullYear() + "-" + m
    } else {
      return t
    }
  },
  //查找用户组树结构路径
  findPath(node, userGroupId, path) {
    if (!path) {
      path = [];
    }
    if (node.userGroupId === userGroupId) {
      return path;
    }
    path.push(node);
    if (node.children) {
      if (
        node.children.some(child => this.findPath(child, userGroupId, path))
      ) {
        return path;
      }
    }

    path.pop();
    return false;
  },
  //获取系统时间 年月日
  getDay(day) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  },
  //配合上GetDay函数使用的
  doHandleMonth(month) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  },
  //分钟转化为小时，天,用在定位里边的车辆
  changeTime(t) {
    var m;
    if (t == null) {
      m = "";
    } else {
      if (t / 60 < 1) {
        if (t == 0) {
          m = "刚刚";
        } else {
          m = t + "分钟前";
        }
      } else if (t / 60 >= 1 && t / 60 < 24) {
        m = parseInt(t / 60) + "小时前";
      } else if (t / 60 >= 24) {
        m = parseInt(t / 60 / 24) + "天前";
      }
    }

    return m;
  },
  //精确计算时间
  changeTimeDetail(t) {
    var m;
    let min = t % 24;
    if (t / 60 < 1) {
      m = "";
    } else if (t / 60 >= 1 && t / 60 < 24) {
      m = parseInt(t / 60) + "小时" + (min < 10 ? "0" + min : min) + "分";
    } else if (t / 60 >= 24) {
      let h = parseInt((t % 1440) / 60); //一天1440分钟
      m =
        parseInt(t / 60 / 24) +
        "天" +
        (h < 10 ? "0" + h : h) +
        "小时" +
        (min < 10 ? "0" + min : min) +
        "分";
    }
    return m;
  },
  //重置表单
  resetForm(_this, name) {
    _this.$refs[name].resetFields();
  }
};
//在main中引用，在实际的组件中就可以调用各种方法了
//组件中调用方法：this.utils.exportData(this, m, "车辆日常报表");



// WEBPACK FOOTER //
// ./src/util/util.js